var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNatureZen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 580,
    viewBox: "0 0 360 580",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gnz",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#43e97b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#38f9d7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 580,
    fill: "url(#gnz)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,450 L90,380 L180,450 L270,360 L360,440 L360,580 L0,580 Z",
    fill: "rgba(255,255,255,0.15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,480 L90,420 L180,480 L270,400 L360,470 L360,580 L0,580 Z",
    fill: "rgba(255,255,255,0.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatureZen);
export default __webpack_public_path__ + "static/media/nature-zen.26a961b7cd39d90a2cf6ecd505466615.svg";
export { ForwardRef as ReactComponent };